/* eslint-disable import/prefer-default-export */

import {
  CONFIRM_CHANGED,
  ACTIVE_MENU_ITEM_CHANGED,
  UPDATE_CONFIRM,
  PERFORMER_REMOVED,
  PERFORMER_ADDED,
  PERFORMER_UPDATED,
  PERFORMER_DRAGGED,
  PAGE_DETAIL_CREATED,
  PAGE_DETAIL_REMOVED,
  PAGE_DETAIL_CHANGED,
  PAGE_DETAIL_DRAGGED,
  ACTIVE_TICKETING_MENU_ITEM_CHANGED,
  TICKET_TYPE_FOR_FORM_CHANGED,
  PROMO_CODE_FOR_FORM_CHANGED,
  PROMO_CODE_DELETED,
  PROMO_CODE_ADDED,
  PROMO_CODE_UPDATED,
  MAIN_EVENT_IMAGE_LOADING_CHANGED,
  WEBSITE_EVENT_IMAGE_LOADING_CHANGED,
  ADD_ONS_CHANGED,
  ADD_ON_FOR_FORM_CHANGED,
  ADD_ON_ADDED,
  ADD_ON_DELETED,
  ADD_ON_UPDATED,
  ADD_ON_DRAGGED,
  STATEMENT_DESCRIPTOR_SUFFIX_CHANGED,
  ARTIST_BIOS_CHANGED,
  PAGE_DETAIL_TEMPLATES_CHANGED,
  PAGE_DETAIL_TEMPLATE_DELETED,
  PAGE_DETAIL_TEMPLATE_CHANGED,
  PAGE_DETAIL_TEMPLATE_ADDED,
  EXAMPLE_TICKET_CHANGED,
  IS_LOADING_DEFAULT_TICKET_TYPES_CHANGED,
  IS_EDITING_ADD_ONS_INTRO_CHANGED,
  ADD_ONS_INTRO_EDITOR_STATE_CHANGED,
  IS_LOADING_DEFAULT_ADD_ONS_CHANGED,
  IS_EDITING_ADD_ONS_ALERT_MESSAGE_CHANGED,
  ADD_ONS_ALERT_MESSAGE_EDITOR_STATE_CHANGED,
  REQUIRE_PER_TICKET_CUSTOM_CHARGE_TYPE_ADDED,
  REQUIRE_PER_TICKET_CUSTOM_CHARGE_TYPE_CHANGED,
  REQUIRE_PER_TICKET_CUSTOM_CHARGE_TYPE_DELETED,
  WARN_BEFORE_LEAVING_CHANGED,
  WARN_BEFORE_LEAVING_OPEN_CHANGED,
  WARN_BEFORE_LEAVING_CALLBACK_CHANGED,
  CHECKOUT_CATEGORIES_CHANGED,
  WIDGET_CONFIG_CHANGED,
  CHECKOUT_STRUCTURE_SELF_MANAGED,
  TICKET_GROUP_CHANGED,
  SEATING_CHARTS_CHANGED,
  ADD_ON_SEATING_CHARTS_CHANGED,
  ADMISSION_SEATING_CHART_EVENT_CHANGED,
  ADD_ON_SEATING_CHART_EVENT_CHANGED,
  SEATING_CHART_EVENTS_CHANGED,
  KILLS_CHANGED,
  KILL_FOR_FORM_CHANGED,
  KILL_ADDED,
  KILL_UPDATED,
  KILL_DELETED,
  HOLDS_CHANGED,
  HOLD_FOR_FORM_CHANGED,
  HOLD_ADDED,
  HOLD_UPDATED,
  HOLD_DELETED,
  GENERAL_ADMISSION_HOLDS_CHANGED,
  GENERAL_ADMISSION_HOLD_ADDED,
  GENERAL_ADMISSION_HOLD_UPDATED,
  GENERAL_ADMISSION_HOLD_DELETED,
  ADD_ON_MESSAGE_TEMPLATE_ADDED,
  ADD_ON_MESSAGE_TEMPLATE_DELETED,
  ADD_ON_MESSAGE_TEMPLATE_CHANGED,
} from '../constants/confirmTicketingConstants';

const axios = require('axios').default;
import { toast } from 'react-toastify';
import { toastError, toastSuccess } from '../../../shared/toastHelper';
import { serialize } from 'object-to-formdata';

import { richTextToHtml } from '../../shared/utils/richTextHtml';
import { isCustomPrice, sharesPool } from '../utils/presaleWindows';
import { quantityPricePoint, soldCountThreshold } from '../utils/ticketPricePoints';
import { priceOptionsAttributes, priceOptionsForForm } from '../utils/priceOptions';

import {
  offsetDateForBrowser,
  offsetDateForServer
} from '../../../shared/timeZoneLogic';

const parseFloatFromString = (value) => {
  if(typeof(value) === "number"){
    return value;
  }

  return parseFloat(value.split(",").join(""));
}

const parseDecimalFromString = (value) => {
  if(typeof(value) === "number"){
    return value.toFixed(2);
  }

  const numValue = parseFloat(value.split(",").join(""));
  return numValue.toFixed(2);
}

export const activeMenuItemChanged = (activeMenuItem) => ({
  type: ACTIVE_MENU_ITEM_CHANGED,
  activeMenuItem
});

export const confirmChanged = (confirm) => ({
  type: CONFIRM_CHANGED,
  confirm
});

export const updateConfirm = (confirm) => ({
  type: UPDATE_CONFIRM,
  confirm
});

export const autoSaveConfirm = (dispatch, csrfToken, team, confirm, throwError, onSuccess, options = {}) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.patch("/teams/" + team.id + "/confirms/" + confirm.id, {
        confirm: {
          title: confirm.title,
          presenter: confirm.presenter,
          venue_capacity: parseFloatFromString(confirm.venue_capacity || ""),
          venue_id: (confirm.venue ? confirm.venue.id : ""),
          venue_ownership_id: confirm.venue_ownership_id,
          room_ids: confirm.room_ids || [],
          age_restriction: confirm.age_restriction,
          start_time: confirm.start_time,
          door_time: confirm.door_time,
          end_time: confirm.end_time,
          ticketing_arrangement: confirm.ticketing_arrangement,
          seating_chart_id: confirm.seating_chart_id,
          add_on_ticketing_arrangement: confirm.add_on_ticketing_arrangement,
          add_on_seating_chart_id: confirm.add_on_seating_chart_id,
          has_add_ons_intro: confirm.has_add_ons_intro,
          add_ons_intro: confirm.add_ons_intro,
          has_add_ons_alert_message: confirm.has_add_ons_alert_message,
          add_ons_alert_message: confirm.add_ons_alert_message,
          max_tickets_per_email:  confirm.max_tickets_per_email,
          promote_on_bandsintown: confirm.promote_on_bandsintown,
          checkout_captcha_enabled: confirm.checkout_captcha_enabled,
          allow_orphan_seats: confirm.allow_orphan_seats,
          enable_all_in_pricing: confirm.enable_all_in_pricing,
          delivery_type: confirm.delivery_type,
          delivery_time: offsetDateForServer(confirm.delivery_time),
          check_in_period: confirm.check_in_period,
          tixel_waitlist_redirect_enabled: confirm.tixel_waitlist_redirect_enabled,
          collect_waitlist_interest_enabled: confirm.collect_waitlist_interest_enabled,
          show_support_acts_under_title: confirm.show_support_acts_under_title,
          secret_location_label: confirm.secret_location_label,
          // Both sent only by the control that owns them. Every tab PATCHes the whole
          // record, so a tab left open while a scheduled reveal fires would keep posting
          // the stale "hidden" and trip the one-way reveal lock -- turning every later
          // save from that page, of any unrelated field, into a failure. reveal_location_at
          // is worse: the reveal nils the column server-side, so a stale tab posts a past
          // timestamp that fails validation (500s the unrelated edit), and a tab that
          // loaded before the time was set posts null and silently deletes the schedule.
          ...(options.includeLocationPrivacy
            ? { location_privacy: confirm.location_privacy }
            : {}),
          ...(options.includeRevealLocationAt
            ? { reveal_location_at: offsetDateForServer(confirm.reveal_location_at) }
            : {}),
          ...(options.includeSkipTicketDelivery
            ? { skip_ticket_delivery: confirm.skip_ticket_delivery }
            : {})
        }
      })
      .then(({ data }) => {
        onSuccess(data);
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });

        if(throwError) {
          throw error;
        }
      });
  };
};

export const deletePerformer = (dispatch, csrfToken, team, performer) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.delete("/teams/" + team.id + "/performers/" + performer.id)
      .then(({ data }) => {
        dispatch(performerRemoved(data));
      })
      .catch((error) => {
        // dispatch(updateEventToEditErrors(error.response.data));
      });
  };
};

export const performerRemoved = (performer) => ({
  type: PERFORMER_REMOVED,
  performer
});

export const createPerformer = (dispatch, csrfToken, team, confirm, artist) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post("/teams/" + team.id + "/performers", {
        performer: {
          artistable_type: "Artist",
          artistable_id: artist.value,
          performable_id: confirm.id,
          performable_type: "CalendarEvent"
        }
      })
      .then(({ data }) => {
        dispatch(performerAdded(data));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const performerAdded = (performer) => ({
  type: PERFORMER_ADDED,
  performer
});

export const updatePerformer = (dispatch, csrfToken, team, performer) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.patch("/teams/" + team.id + "/performers/" + performer.id, {
        performer: {
          act_type: performer.act_type,
          position: performer.position
        }
      })
      .then(({ data }) => {
        dispatch(performerUpdated(data));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const performerUpdated = (performer) => ({
  type: PERFORMER_UPDATED,
  performer
});

export const createPageDetail = (dispatch, csrfToken, team, confirm, pageDetail) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post("/teams/" + team.id + "/page_details", {
        page_detail: {
          type: pageDetail.type,
          calendar_event_id: pageDetail.calendar_event_id,
          position: pageDetail.position
        }
      })
      .then(({ data }) => {
        dispatch(pageDetailCreated(data));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const pageDetailCreated = (pageDetail) => ({
  type: PAGE_DETAIL_CREATED,
  pageDetail
});

export const deletePageDetail = (dispatch, csrfToken, team, pageDetail) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.delete("/teams/" + team.id + "/page_details/" + pageDetail.id)
      .then(({ data }) => {
        dispatch(pageDetailRemoved(data));
      })
      .catch((error) => {
        // dispatch(updateEventToEditErrors(error.response.data));
      });
  };
};

export const pageDetailRemoved = (pageDetail) => ({
  type: PAGE_DETAIL_REMOVED,
  pageDetail
});

export const pageDetailChanged = (pageDetail) => ({
  type: PAGE_DETAIL_CHANGED,
  pageDetail
});

export const autoSavePageDetail = (dispatch, csrfToken, team, pageDetail) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    var pageDetailParams;

    switch(pageDetail.type) {
      case "PageDetails::Text":
        pageDetailParams = {
          position: pageDetail.position,
          body: (pageDetail.body ? richTextToHtml(pageDetail.body.getCurrentContent()) : "")
        }
        break;
      case "PageDetails::Image":
        pageDetailParams = {
          position: pageDetail.position
        }
        break;
      case "PageDetails::Video":
        pageDetailParams = {
          position: pageDetail.position,
          video_url: pageDetail.video_url
        }
        break;
    }

    return axios.patch("/teams/" + team.id + "/page_details/" + pageDetail.id, {
        page_detail: pageDetailParams
      })
      .then(({ data }) => {
        if(pageDetail.type !== "PageDetails::Text"){
          dispatch(pageDetailChanged(data));
        }
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const pageDetailDragged = (result) => ({
  type: PAGE_DETAIL_DRAGGED,
  result
});

export const uploadPageDetailImage = (dispatch, csrfToken, team, pageDetail, file) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    var updated = Object.assign({}, pageDetail, {_isLoading: true});
    dispatch(pageDetailChanged(updated));

    var formData = new FormData();
    formData.append("page_detail[image]", file);

    return axios.patch("/teams/" + team.id + "/page_details/" + pageDetail.id, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(({ data }) => {
        pageDetail = Object.assign({}, data);
        dispatch(pageDetailChanged(pageDetail));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      }).then(() => {
        var updated = Object.assign({}, pageDetail, {_isLoading: false});
        dispatch(pageDetailChanged(updated));
      });
  };
};

export const uploadPageDetailImageUrl = (dispatch, csrfToken, team, pageDetail, url) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    var updated = Object.assign({}, pageDetail, {_isLoading: true});
    dispatch(pageDetailChanged(updated));

    return axios.patch("/teams/" + team.id + "/page_details/" + pageDetail.id, {
        page_detail: {
          image_url: url
        }
      })
      .then(({ data }) => {
        pageDetail = Object.assign({}, data);
        dispatch(pageDetailChanged(pageDetail));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      }).then(() => {
        var updated = Object.assign({}, pageDetail, {_isLoading: false});
        dispatch(pageDetailChanged(updated));
      });
  };
};

// The crop happens in the browser, so the file we upload as the image is already
// cropped. Send the pre-crop file alongside it when we have one, so other ratios can
// be derived from full source detail later. Reframing an image whose source is
// already stored sends no file -- the stored source is still the right one.
//
// The crop field is always sent, even as "": a re-crop we could not measure against
// the source has to CLEAR the stored framing, because a stale box still parses and
// still fits, so nothing downstream could tell it no longer describes the crop.
const appendImageSource = (formData, attribute, sourceFile, crop) => {
  if (sourceFile) {
    formData.append(`confirm[${attribute}_source]`, sourceFile);
  }

  formData.append(`confirm[${attribute}_crop]`, crop ? JSON.stringify(crop) : "");
};

export const uploadConfirmMainImageFile = (dispatch, csrfToken, team, confirm, file, sourceFile, crop) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    dispatch(mainEventImageLoadingChanged(true));

    var formData = new FormData();
    formData.append("confirm[main_event_image]", file);
    appendImageSource(formData, "main_event_image", sourceFile, crop);

    return axios.patch("/teams/" + team.id + "/confirms/" + confirm.id, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(({ data }) => {
        dispatch(updateConfirm(data));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      }).then(() => {
        dispatch(mainEventImageLoadingChanged(false));
      });
  };
};

export const uploadConfirmMainImageUrl = (dispatch, csrfToken, team, confirm, url) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    dispatch(mainEventImageLoadingChanged(true));

    return axios.patch("/teams/" + team.id + "/confirms/" + confirm.id, {
        confirm: {
          main_event_image_url: url
        }
      })
      .then(({ data }) => {
        dispatch(updateConfirm(data));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      }).then(() => {
        dispatch(mainEventImageLoadingChanged(false));
      });
  };
};

export const uploadConfirmWebsiteImageFile = (dispatch, csrfToken, team, confirm, file, sourceFile, crop) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    dispatch(websiteEventImageLoadingChanged(true));

    var formData = new FormData();
    formData.append("confirm[website_event_image]", file);
    appendImageSource(formData, "website_event_image", sourceFile, crop);

    return axios.patch("/teams/" + team.id + "/confirms/" + confirm.id, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(({ data }) => {
        dispatch(updateConfirm(data));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      }).then(() => {
        dispatch(websiteEventImageLoadingChanged(false));
      });
  };
};

export const uploadConfirmWebsiteImageUrl = (dispatch, csrfToken, team, confirm, url) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    dispatch(websiteEventImageLoadingChanged(true));

    return axios.patch("/teams/" + team.id + "/confirms/" + confirm.id, {
        confirm: {
          website_event_image_url: url
        }
      })
      .then(({ data }) => {
        dispatch(updateConfirm(data));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      }).then(() => {
        dispatch(websiteEventImageLoadingChanged(false));
      });
  };
};

export const activeTicketingMenuItemChanged = (menuItem) => ({
  type: ACTIVE_TICKETING_MENU_ITEM_CHANGED,
  menuItem
});

export const ticketTypeForFormChanged = (ticketType) => ({
  type: TICKET_TYPE_FOR_FORM_CHANGED,
  ticketType
});

export const fetchNewTicketType = (dispatch, csrfToken, team, confirm, ticketGroup, ticketTypeToCopy) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    var url = "/teams/" + team.id + "/ticket_types/new?confirm_id=" + confirm.id;
    if(ticketTypeToCopy){
      url = (url + "&copy_from_id=" + ticketTypeToCopy.id);
    }

    return axios.get(url)
      .then(({ data }) => {
        var ticketType = Object.assign({}, data, {
          start_time: offsetDateForBrowser(data.start_time),
          end_time: offsetDateForBrowser(data.end_time),
          ticketGroup: ticketGroup,
          ticket_group_id: ticketGroup.id
        });

        dispatch(ticketTypeForFormChanged(ticketType));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const fetchTicketTypeForEdit = (dispatch, csrfToken, team, ticketType, ticketGroup) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.get("/teams/" + team.id + "/ticket_types/" + ticketType.id  + "/edit")
      .then(({ data }) => {
        var ticketType = Object.assign({}, data, {
          start_time: offsetDateForBrowser(data.start_time),
          end_time: offsetDateForBrowser(data.end_time),
          timed_entry_start: offsetDateForBrowser(data.timed_entry_start),
          timed_entry_end: offsetDateForBrowser(data.timed_entry_end),
          presale_windows: (data.presale_windows || []).map((w) => ({
            ...w,
            available: w.available === data.available ? '' : w.available,
            start_time: offsetDateForBrowser(w.start_time),
            end_time: offsetDateForBrowser(w.end_time),
          })),
          price_options: priceOptionsForForm(data),
          ticketGroup: ticketGroup,
          ticket_group_id: ticketGroup.id
        });

        dispatch(ticketTypeForFormChanged(ticketType));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const ticketTypeParams = (ticketType, confirm) => {
  const removePricePoints = (
    ticketType.free || (
      ticketType.availability !== "Date & Time" &&
      ticketType.availability !== "Based on show details"
    )
  );

  var params = {
    name: ticketType.base_name,
    description: ticketType.description,
    available: (ticketType.available ? parseFloatFromString(ticketType.available) : null),
    price: (ticketType.base_price_two_decimals ? parseDecimalFromString(ticketType.base_price_two_decimals) : null),
    settlement_amount: (ticketType.settlement_amount_two_decimals ? parseDecimalFromString(ticketType.settlement_amount_two_decimals) : null),
    fair_market_value: (!ticketType.free && ticketType.fair_market_value_two_decimals ? parseDecimalFromString(ticketType.fair_market_value_two_decimals) : null),
    goods_services_description: (!ticketType.free && ticketType.fair_market_value_two_decimals ? ticketType.goods_services_description || null : null),
    availability: ticketType.availability,
    minimum_tickets_per_order: ticketType.minimum_tickets_per_order,
    maximum_tickets_per_order: ticketType.maximum_tickets_per_order,
    free: ticketType.free,
    visibility: ticketType.original_visibility,
    sales_channel: ticketType.sales_channel,
    has_fixed_fees: ticketType.has_fixed_fees,
    fixed_fee_amount: (ticketType.fixed_fee_amount_two_decimals ? parseDecimalFromString(ticketType.fixed_fee_amount_two_decimals) : "0.00"),
    position: ticketType.position,
    absorb_fees: ticketType.absorb_fees,
    round_up: ticketType.round_up,
    dynamic_pricing_enabled: ticketType.dynamic_pricing_enabled,
    dynamic_pricing_min: ticketType.dynamic_pricing_min ? parseDecimalFromString(ticketType.dynamic_pricing_min) : null,
    dynamic_pricing_max: ticketType.dynamic_pricing_max ? parseDecimalFromString(ticketType.dynamic_pricing_max) : null,
    should_be_default: ticketType.should_be_default,
    manifested: ticketType.manifested,
    start_time: offsetDateForServer(ticketType.start_time),
    end_time: offsetDateForServer(ticketType.end_time),
    start_show_activity_id: ticketType.start_show_activity_id,
    end_show_activity_id: ticketType.end_show_activity_id,
    wait_for_ticket_type_id: ticketType.wait_for_ticket_type_id,
    taxable_items_attributes: ticketType.taxable_items || [],
    has_bundled_ticket_type: ticketType.has_bundled_ticket_type,
    bundled_ticket_type_id: ticketType.bundled_ticket_type_id,
    hide_qr_code: ticketType.hide_qr_code,
    skip_ticket_delivery: ticketType.skip_ticket_delivery,
    accessible_seating: ticketType.accessible_seating,
    member_presale: ticketType.member_presale,
    timed_entry: ticketType.timed_entry,
    timed_entry_availability: ticketType.timed_entry_availability,
    timed_entry_start: offsetDateForServer(ticketType.timed_entry_start),
    timed_entry_end: offsetDateForServer(ticketType.timed_entry_end),
    timed_entry_start_show_activity_id: ticketType.timed_entry_start_show_activity_id,
    timed_entry_end_show_activity_id: ticketType.timed_entry_end_show_activity_id,
    check_in_limit: ticketType.check_in_limit,
    check_in_period: ticketType.check_in_period,
    ticket_group_id: ticketType.ticket_group_id,
    opendate_distribution: ticketType.opendate_distribution,
    price_points_attributes: (ticketType.price_points || []).map((pricePoint) => {
      return {
        id: pricePoint.newRecord ? "" : pricePoint.id,
        price: (pricePoint.price_two_decimals ? parseDecimalFromString(pricePoint.price_two_decimals) : null),
        starts_at: quantityPricePoint(pricePoint) ? null : offsetDateForServer(pricePoint.starts_at),
        sold_count_threshold: quantityPricePoint(pricePoint) ? soldCountThreshold(pricePoint) : null,
        name: pricePoint.name,
        _destroy: pricePoint._destroy || removePricePoints ? "true" : ""
      }
    }),
    presale_windows_attributes: (ticketType.presale_windows || []).map((w) => ({
      id: w.newRecord ? '' : w.id,
      name: w.name,
      price: isCustomPrice(w, ticketType) ? parseDecimalFromString(w.price_two_decimals) : null,
      available: sharesPool(w, ticketType.available) ? null : parseInt(String(w.available).replace(/,/g, ''), 10),
      availability: w.availability,
      start_show_activity_id: w.start_show_activity_id,
      end_show_activity_id: w.end_show_activity_id,
      start_time: offsetDateForServer(w.start_time),
      end_time: offsetDateForServer(w.end_time),
      access_code: w.access_code_managed === false ? undefined : (w.access_code || ''),
      enabled: w.enabled !== false,
      _destroy: w._destroy ? 'true' : '',
    })),
  };

  const priceOptions = priceOptionsAttributes(ticketType);
  if (priceOptions) {
    params.price_options_attributes = priceOptions;
  }

  if(confirm && confirm.id){
    params = Object.assign({}, params, {
      calendar_event_id: confirm.id
    });
  }

  return params;
}

export const mainEventImageLoadingChanged = (mainEventImageLoading) => ({
  type: MAIN_EVENT_IMAGE_LOADING_CHANGED,
  mainEventImageLoading
});

export const websiteEventImageLoadingChanged = (websiteEventImageLoading) => ({
  type: WEBSITE_EVENT_IMAGE_LOADING_CHANGED,
  websiteEventImageLoading
});

export const publishConfirm = (dispatch, csrfToken, team, confirm) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post("/teams/" + team.id + "/confirms/" + confirm.id + "/publish", {
        confirm: {
          published_at: (confirm.is_public ? offsetDateForServer(confirm.published_at) : new Date()),
          is_public: confirm.is_public,
        }
      })
      .then(({ data }) => {
        window.location.replace("/teams/" + team.id + "/confirms/" + confirm.id);
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const fetchNewAddOn = (dispatch, csrfToken, team, confirm, addOnToCopy, presetId) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    var url = "/teams/" + team.id + "/add_ons/new?confirm_id=" + confirm.id;
    if(addOnToCopy){
      url = (url + "&copy_from_id=" + addOnToCopy.id);
    }
    if(presetId){
      url = (url + "&preset_id=" + presetId);
    }

    return axios.get(url)
      .then(({ data }) => {
        var addOn = Object.assign({}, data, {
          start_time: offsetDateForBrowser(data.start_time),
          end_time: offsetDateForBrowser(data.end_time),
          has_image: !!data.image_url,
          image_file_info: data.image_file_name ? {
            name: data.image_file_name,
            size: data.image_file_size ? `${Math.round(data.image_file_size / 1024)} KB` : ''
          } : null,
          price_points: (data.price_points || []).map((pricePoint, index) => (
            pricePoint.id ? pricePoint : { ...pricePoint, id: `preset-${index}`, newRecord: true }
          ))
        });

        dispatch(addOnForFormChanged(addOn));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const addOnForFormChanged = (addOn) => ({
  type: ADD_ON_FOR_FORM_CHANGED,
  addOn
});

export const addOnParams = (addOn, confirm=null) => {
  var params = {
    add_on: {
      name: addOn.base_name,
      description: addOn.description,
      absorb_fees: addOn.absorb_fees,
      round_up: addOn.round_up,
      dynamic_pricing_enabled: addOn.dynamic_pricing_enabled,
      dynamic_pricing_min: (addOn.dynamic_pricing_min ? parseDecimalFromString(addOn.dynamic_pricing_min) : null),
      dynamic_pricing_max: (addOn.dynamic_pricing_max ? parseDecimalFromString(addOn.dynamic_pricing_max) : null),
      confirmation_details: addOn.confirmation_details,
      available: (addOn.available ? parseFloatFromString(addOn.available) : null),
      availability: addOn.availability,
      price: (addOn.base_price_two_decimals ? parseDecimalFromString(addOn.base_price_two_decimals) : null),
      minimum_per_order: (addOn.minimum_per_order ? parseFloatFromString(addOn.minimum_per_order) : null),
      maximum_per_order: (addOn.maximum_per_order ? parseFloatFromString(addOn.maximum_per_order) : null),
      require_ticket_type: addOn.require_ticket_type,
      require_add_on: addOn.require_add_on,
      limit_quantity_to_admission_count: addOn.limit_quantity_to_admission_count,
      disable_require_ticket_type_with_direct_link: addOn.disable_require_ticket_type_with_direct_link,
      transferable: addOn.transferable,
      accessible_seating: addOn.accessible_seating,
      sales_channel: addOn.sales_channel,
      ticket_type_ids: (addOn.ticket_type_ids ? addOn.ticket_type_ids : []),
      required_add_on_ids: (addOn.required_add_on_ids ? addOn.required_add_on_ids : []),
      position: addOn.position,
      start_time: offsetDateForServer(addOn.start_time),
      end_time: offsetDateForServer(addOn.end_time),
      start_show_activity_id: addOn.start_show_activity_id,
      end_show_activity_id: addOn.end_show_activity_id,
      hide_qr_code: addOn.hide_qr_code,
      taxable_items_attributes: addOn.taxable_items,
      timed_entry: addOn.timed_entry,
      timed_entry_availability: addOn.timed_entry_availability,
      timed_entry_start: offsetDateForServer(addOn.timed_entry_start),
      timed_entry_end: offsetDateForServer(addOn.timed_entry_end),
      timed_entry_start_show_activity_id: addOn.timed_entry_start_show_activity_id,
      timed_entry_end_show_activity_id: addOn.timed_entry_end_show_activity_id,
      check_in_limit: addOn.check_in_limit,
      check_in_period: addOn.check_in_period,
      remove_image: addOn.remove_image,
      price_points_attributes: addOn.price_points.map((pricePoint) => {
        return {
          id: pricePoint.newRecord ? "" : pricePoint.id,
          price: (pricePoint.price_two_decimals ? parseDecimalFromString(pricePoint.price_two_decimals) : null),
          starts_at: offsetDateForServer(pricePoint.starts_at),
          name: pricePoint.name,
          _destroy: pricePoint._destroy ? "true" : ""
        }
      })
    }
  };

  if (confirm) {
    params.add_on.calendar_event_id = confirm.id;
  }

  return params
}

const addOnFormData = (addOn, confirm=null) => {
  const params = addOnParams(addOn, confirm);

  const formData = serialize(params, {
    indices: false,
    booleansAsIntegers: false,
    allowEmptyArrays: true,
    noAttributesWithArrayNotation: false,
    noFilesWithArrayNotation: true,
    dotsForObjectNotation: false
  });

  if (addOn.image_file) {
    formData.append('add_on[image]', addOn.image_file);
  }

  return formData;
}

export const createAddOn = (dispatch, csrfToken, team, confirm, addOn) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post("/teams/" + team.id + "/add_ons", addOnFormData(addOn, confirm), {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(({ data }) => {
        dispatch(addOnAdded(data));
        dispatch(addOnForFormChanged({}));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const addOnAdded = (addOn) => ({
  type: ADD_ON_ADDED,
  addOn
});

export const fetchAddOnToEdit = (dispatch, csrfToken, team, addOn) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.get("/teams/" + team.id + "/add_ons/" + addOn.id + "/edit")
      .then(({ data }) => {
        var addOn = Object.assign({}, data, {
          start_time: offsetDateForBrowser(data.start_time),
          end_time: offsetDateForBrowser(data.end_time),
          has_image: !!data.image_url,
          image_file_info: data.image_file_name ? {
            name: data.image_file_name,
            size: data.image_file_size ? `${Math.round(data.image_file_size / 1024)} KB` : ''
          } : null
        });

        dispatch(addOnForFormChanged(addOn));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const deleteAddOn = (dispatch, csrfToken, team, addOn) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.delete("/teams/" + team.id + "/add_ons/" + addOn.id)
      .then(({ data }) => {
        dispatch(addOnDeleted(data));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const addOnDeleted = (addOn) => ({
  type: ADD_ON_DELETED,
  addOn
});

export const updateAddOn = (dispatch, csrfToken, team, addOn) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.patch("/teams/" + team.id + "/add_ons/" + addOn.id, addOnFormData(addOn, null), {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
      .then(({ data }) => {
        dispatch(addOnUpdated(data));
        dispatch(addOnForFormChanged({}));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const addOnUpdated = (addOn) => ({
  type: ADD_ON_UPDATED,
  addOn
});

export const addOnDragged = (result) => ({
  type: ADD_ON_DRAGGED,
  result
});

export const statementDescriptorSuffixChanged = (statementDescriptorSuffix) => ({
  type: STATEMENT_DESCRIPTOR_SUFFIX_CHANGED,
  statementDescriptorSuffix
});

export const updateStatementDescriptorSuffix = (dispatch, csrfToken, team, confirm, statementDescriptorSuffix) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.patch("/teams/" + team.id + "/confirms/" + confirm.id, {
        confirm: {
          statement_descriptor_suffix: statementDescriptorSuffix
        }
      })
      .then(({ data }) => {
        dispatch(updateConfirm(data));

        toast.success("Credit Card Statement Descriptor successfully updated", {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const artistBiosChanged = (artistBios) => ({
  type: ARTIST_BIOS_CHANGED,
  artistBios
});

export const pageDetailTemplatesChanged = (pageDetailTemplates) => ({
  type: PAGE_DETAIL_TEMPLATES_CHANGED,
  pageDetailTemplates
});

export const deletePageDetailTemplate = (dispatch, csrfToken, team, pageDetailTemplate) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.delete("/teams/" + team.id + "/page_detail_templates/" + pageDetailTemplate.id)
      .then(({ data }) => {
        dispatch(pageDetailTemplateDeleted(pageDetailTemplate));
      })
      .catch((error) => {
        // dispatch(updateEventToEditErrors(error.response.data));
      });
  };
};

export const pageDetailTemplateDeleted = (pageDetailTemplate) => ({
  type: PAGE_DETAIL_TEMPLATE_DELETED,
  pageDetailTemplate
});

export const pageDetailTemplateChanged = (pageDetailTemplate) => ({
  type: PAGE_DETAIL_TEMPLATE_CHANGED,
  pageDetailTemplate
});

export const createPageDetailTemplate = (dispatch, csrfToken, team, pageDetailTemplate, body, onSuccess) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post("/teams/" + team.id + "/page_detail_templates", {
        page_detail_template: {
          name: pageDetailTemplate.name,
          body: body
        }
      })
      .then(({ data }) => {
        dispatch(pageDetailTemplateChanged({}));
        dispatch(pageDetailTemplateAdded(data));
        onSuccess(data);

        toast.success("Template has been saved", {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const pageDetailTemplateAdded = (pageDetailTemplate) => ({
  type: PAGE_DETAIL_TEMPLATE_ADDED,
  pageDetailTemplate
});

export const addOnMessageTemplateAdded = (addOnMessageTemplate) => ({
  type: ADD_ON_MESSAGE_TEMPLATE_ADDED,
  addOnMessageTemplate,
});

export const addOnMessageTemplateDeleted = (addOnMessageTemplate) => ({
  type: ADD_ON_MESSAGE_TEMPLATE_DELETED,
  addOnMessageTemplate,
});

export const addOnMessageTemplateChanged = (kind, addOnMessageTemplate) => ({
  type: ADD_ON_MESSAGE_TEMPLATE_CHANGED,
  kind,
  addOnMessageTemplate,
});

export const createAddOnMessageTemplate = (dispatch, csrfToken, team, kind, draft, body, onSuccess) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post("/teams/" + team.id + "/add_on_message_templates", {
        add_on_message_template: {
          title: draft.title,
          body: body,
          kind: kind
        }
      })
      .then(({ data }) => {
        dispatch(addOnMessageTemplateChanged(kind, {}));
        dispatch(addOnMessageTemplateAdded(data));
        if (onSuccess) { onSuccess(data); }

        toast.success("Template has been saved", {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const deleteAddOnMessageTemplate = (dispatch, csrfToken, team, addOnMessageTemplate) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.delete("/teams/" + team.id + "/add_on_message_templates/" + addOnMessageTemplate.id)
      .then(({ data }) => {
        dispatch(addOnMessageTemplateDeleted(addOnMessageTemplate));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const performerDragged = (result) => ({
  type: PERFORMER_DRAGGED,
  result
});

export const buildExampleTicket = (dispatch, csrfToken, team, confirm, ticketType) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    var normalParams = ticketTypeParams(ticketType, confirm);
    var params = {
      price: normalParams.price,
      free: normalParams.free,
      has_fixed_fees: normalParams.has_fixed_fees,
      fixed_fee_amount: normalParams.fixed_fee_amount,
      absorb_fees: normalParams.absorb_fees,
      calendar_event_id: normalParams.calendar_event_id,
      taxable_items_attributes: normalParams.taxable_items_attributes.map((taxableItem) => {
        return {...taxableItem, id: ""};
      })
    };

    return axios.post("/teams/" + team.id + "/ticket_types/build_ticket", {
        ticket_type: params
      })
      .then(({ data }) => {
        dispatch(exampleTicketChanged(data));
      });
  };
};

export const exampleTicketChanged = (exampleTicket) => ({
  type: EXAMPLE_TICKET_CHANGED,
  exampleTicket
});

export const isLoadingDefaultTicketTypesChanged = (isLoadingDefaultTicketTypes) => ({
  type: IS_LOADING_DEFAULT_TICKET_TYPES_CHANGED,
  isLoadingDefaultTicketTypes
});

export const isEditingAddOnsIntroChanged = (isEditingAddOnsIntro) => ({
  type: IS_EDITING_ADD_ONS_INTRO_CHANGED,
  isEditingAddOnsIntro
});

export const addOnsIntroEditorStateChanged = (addOnsIntroEditorState) => ({
  type: ADD_ONS_INTRO_EDITOR_STATE_CHANGED,
  addOnsIntroEditorState
});

export const addOnsChanged = (addOns) => ({
  type: ADD_ONS_CHANGED,
  addOns
});

export const isLoadingDefaultAddOnsChanged = (isLoadingDefaultAddOns) => ({
  type: IS_LOADING_DEFAULT_ADD_ONS_CHANGED,
  isLoadingDefaultAddOns
});

export const isEditingAddOnsAlertMessageChanged = (isEditingAddOnsAlertMessage) => ({
  type: IS_EDITING_ADD_ONS_ALERT_MESSAGE_CHANGED,
  isEditingAddOnsAlertMessage
});

export const addOnsAlertMessageEditorStateChanged = (addOnsAlertMessageEditorState) => ({
  type: ADD_ONS_ALERT_MESSAGE_EDITOR_STATE_CHANGED,
  addOnsAlertMessageEditorState
});

export const createRequirePerTicketCustomChargeType = (dispatch, csrfToken, team, confirm) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.post("/teams/" + team.id + "/require_per_ticket_custom_charge_types", {
        custom_charge_type: {
          calendar_event_id: confirm.id
        }
      })
      .then(({ data }) => {
        dispatch(requirePerTicketCustomChargeTypeAdded(data));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const requirePerTicketCustomChargeTypeAdded = (requirePerTicketCustomChargeType) => ({
  type: REQUIRE_PER_TICKET_CUSTOM_CHARGE_TYPE_ADDED,
  requirePerTicketCustomChargeType
});

export const requirePerTicketCustomChargeTypeChanged = (requirePerTicketCustomChargeType) => ({
  type: REQUIRE_PER_TICKET_CUSTOM_CHARGE_TYPE_CHANGED,
  requirePerTicketCustomChargeType
});

export const deleteRequirePerTicketCustomChargeType = (dispatch, csrfToken, team, requirePerTicketCustomChargeType) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.delete("/teams/" + team.id + "/require_per_ticket_custom_charge_types/" + requirePerTicketCustomChargeType.id)
      .then(({ data }) => {
        dispatch(requirePerTicketCustomChargeTypeDeleted(data));
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const requirePerTicketCustomChargeTypeDeleted = (requirePerTicketCustomChargeType) => ({
  type: REQUIRE_PER_TICKET_CUSTOM_CHARGE_TYPE_DELETED,
  requirePerTicketCustomChargeType
});

export const autoSaveRequirePerTicketCustomChargeType = (dispatch, csrfToken, team, requirePerTicketCustomChargeType) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;

    return axios.patch("/teams/" + team.id + "/require_per_ticket_custom_charge_types/" + requirePerTicketCustomChargeType.id, {
        custom_charge_type: {
          name: requirePerTicketCustomChargeType.name,
          default_amount: (requirePerTicketCustomChargeType.default_amount ? parseFloatFromString(requirePerTicketCustomChargeType.default_amount) : ""),
          enabled: requirePerTicketCustomChargeType.enabled
        }
      })
      .then(({ data }) => {
        // ...
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };
};

export const warnBeforeLeavingChanged = (warnBeforeLeaving) => ({
  type: WARN_BEFORE_LEAVING_CHANGED,
  warnBeforeLeaving
});

export const warnBeforeLeavingOpenChanged = (warnBeforeLeavingOpen) => ({
  type: WARN_BEFORE_LEAVING_OPEN_CHANGED,
  warnBeforeLeavingOpen
});

export const warnBeforeLeavingCallbackChanged = (warnBeforeLeavingCallback) => ({
  type: WARN_BEFORE_LEAVING_CALLBACK_CHANGED,
  warnBeforeLeavingCallback
});

export const checkoutCategoriesChanged = (checkoutCategories) => ({
  type: CHECKOUT_CATEGORIES_CHANGED,
  checkoutCategories
});

export const widgetConfigChanged = (widgetConfig) => ({
  type: WIDGET_CONFIG_CHANGED,
  widgetConfig
});

export const checkoutStructureSelfManaged = () => ({
  type: CHECKOUT_STRUCTURE_SELF_MANAGED
});

export const ticketGroupChanged = (ticketGroup) => ({
  type: TICKET_GROUP_CHANGED,
  ticketGroup
});

export const seatingChartsChanged = (seatingCharts) => ({
  type: SEATING_CHARTS_CHANGED,
  seatingCharts
});

export const addOnSeatingChartsChanged = (addOnSeatingCharts) => ({
  type: ADD_ON_SEATING_CHARTS_CHANGED,
  addOnSeatingCharts
});

export const admissionSeatingChartEventChanged = (admissionSeatingChartEvent) => ({
  type: ADMISSION_SEATING_CHART_EVENT_CHANGED,
  admissionSeatingChartEvent
});

export const addOnSeatingChartEventChanged = (addOnSeatingChartEvent) => ({
  type: ADD_ON_SEATING_CHART_EVENT_CHANGED,
  addOnSeatingChartEvent
});

// Kills
export const killsChanged = (kills) => ({
  type: KILLS_CHANGED,
  kills
});

export const killAdded = (kill) => ({
  type: KILL_ADDED,
  kill
});

export const killUpdated = (kill) => ({
  type: KILL_UPDATED,
  kill
});

export const killDeleted = (kill) => ({
  type: KILL_DELETED,
  kill
});

export const killForFormChanged = (kill) => ({
  type: KILL_FOR_FORM_CHANGED,
  kill
});

export const fetchKills = (dispatch, csrfToken, seatingChartEvent, signal) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    const url = `/seating_chart_events/${seatingChartEvent.id}/seating_event_kills`;
    return axios.get(url, { signal })
      .then(({ data }) => dispatch(killsChanged(data.kills)))
      .catch((error) => {
        if (axios.isCancel?.(error) || error?.name === 'CanceledError' || error?.name === 'AbortError') return;
        toastError((error.response && error.response.data && error.response.data.errors || ['An error occurred while fetching the kills']).join(', '));
      });
  };
};

export const createKill = (dispatch, csrfToken, seatingChartEvent, kill) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    const url = `/seating_chart_events/${seatingChartEvent.id}/seating_event_kills`;
    return axios.post(url, { seating_event_kill: { name: kill.name, objects: kill.objects || [], area_places: kill.area_places || {} }})
      .then(({ data }) => {
        dispatch(killAdded(data.kill));
      })
      .then(() => toastSuccess('Kill created successfully'))
      .catch((error) => {
        toastError((error.response && error.response.data && error.response.data.errors || ['An error occurred while creating the kill']).join(', '));
      });
  };
};

export const updateKill = (dispatch, csrfToken, kill) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    const url = `/seating_event_kills/${kill.id}`;
    return axios.patch(url, { seating_event_kill: { name: kill.name, objects: kill.objects || [], area_places: kill.area_places || {} }})
      .then(({ data }) => dispatch(killUpdated(data.kill)))
      .then(() => toastSuccess('Kill updated successfully'))
      .catch((error) => {
        toastError((error.response && error.response.data && error.response.data.errors || ['An error occurred while updating the kill']).join(', '));
      });
  };
};

export const deleteKill = (dispatch, csrfToken, seatingChartEvent, kill) => {
  return dispatch => {
    if(!window.confirm('Are you sure you want to delete this kill?')) return;
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    const url = `/seating_event_kills/${kill.id}`;
    return axios.delete(url)
      .then(() => {
        dispatch(killDeleted(kill));
        toastSuccess('Kill deleted successfully');
      })
      .catch((error) => {
        toastError((error.response && error.response.data && error.response.data.errors || ['An error occurred while deleting the kill']).join(', '));
      });
  };
};

// Holds
export const holdsChanged = (holds) => ({
  type: HOLDS_CHANGED,
  holds
});

export const holdAdded = (hold) => ({
  type: HOLD_ADDED,
  hold
});

export const holdUpdated = (hold) => ({
  type: HOLD_UPDATED,
  hold
});

export const holdDeleted = (hold) => ({
  type: HOLD_DELETED,
  hold
});

export const holdForFormChanged = (hold) => ({
  type: HOLD_FOR_FORM_CHANGED,
  hold
});

export const fetchHolds = (dispatch, csrfToken, seatingChartEvent, signal) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    const url = `/seating_chart_events/${seatingChartEvent.id}/seating_event_holds`;
    return axios.get(url, { signal })
      .then(({ data }) => dispatch(holdsChanged(data.holds)))
      .catch((error) => {
        if (axios.isCancel?.(error) || error?.name === 'CanceledError' || error?.name === 'AbortError') return;
        toastError((error.response && error.response.data && error.response.data.errors || ['An error occurred while fetching the holds']).join(', '));
      });
  };
};

export const createHold = (dispatch, csrfToken, seatingChartEvent, hold) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    const url = `/seating_chart_events/${seatingChartEvent.id}/seating_event_holds`;
    return axios.post(url, { seating_event_hold: hold })
      .then(({ data }) => {
        dispatch(holdAdded(data.hold));
      })
      .then(() => toastSuccess('Hold created successfully'))
      .catch((error) => {
        toastError((error.response && error.response.data && error.response.data.errors || ['An error occurred while creating the hold']).join(', '));
      });
  };
};

export const updateHold = (dispatch, csrfToken, hold) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    const url = `/seating_event_holds/${hold.id}`;
    return axios.patch(url, { seating_event_hold: hold })
      .then(({ data }) => dispatch(holdUpdated(data.hold)))
      .then(() => toastSuccess('Hold updated successfully'))
      .catch((error) => {
        toastError((error.response && error.response.data && error.response.data.errors || ['An error occurred while updating the hold']).join(', '));
      });
  };
};

export const deleteHold = (dispatch, csrfToken, seatingChartEvent, hold) => {
  return dispatch => {
    if(!window.confirm('Are you sure you want to delete this hold?')) return;
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    const url = `/seating_event_holds/${hold.id}`;
    return axios.delete(url)
      .then(() => {
        dispatch(holdDeleted(hold));
        toastSuccess('Hold deleted successfully');
      })
      .catch((error) => {
        toastError((error.response && error.response.data && error.response.data.errors || ['An error occurred while deleting the hold']).join(', '));
      });
  };
};

// GA Holds Actions
export const generalAdmissionHoldsChanged = (holds) => ({
  type: GENERAL_ADMISSION_HOLDS_CHANGED,
  holds
});

export const generalAdmissionHoldAdded = (hold) => ({
  type: GENERAL_ADMISSION_HOLD_ADDED,
  hold
});

export const generalAdmissionHoldUpdated = (hold) => ({
  type: GENERAL_ADMISSION_HOLD_UPDATED,
  hold
});

export const generalAdmissionHoldDeleted = (hold) => ({
  type: GENERAL_ADMISSION_HOLD_DELETED,
  hold
});

export const fetchGeneralAdmissionHolds = (dispatch, csrfToken, calendarEventId) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    const url = `/calendar_events/${calendarEventId}/general_admission_holds`;
    return axios.get(url)
      .then(({ data }) => dispatch(generalAdmissionHoldsChanged(data.holds)))
      .catch((error) => {
        toastError((error.response && error.response.data && error.response.data.errors || ['An error occurred while fetching holds']).join(', '));
      });
  };
};

export const createGeneralAdmissionHold = (dispatch, csrfToken, calendarEventId, hold) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    const url = `/calendar_events/${calendarEventId}/general_admission_holds`;
    return axios.post(url, { general_admission_hold: hold })
      .then(({ data }) => {
        dispatch(generalAdmissionHoldAdded(data.hold));
      })
      .then(() => toastSuccess('Hold created successfully'))
      .catch((error) => {
        toastError((error.response && error.response.data && error.response.data.errors || ['An error occurred while creating hold']).join(', '));
        throw error;
      });
  };
};

export const updateGeneralAdmissionHold = (dispatch, csrfToken, hold) => {
  return dispatch => {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    const url = `/general_admission_holds/${hold.id}`;
    return axios.patch(url, { general_admission_hold: hold })
      .then(({ data }) => dispatch(generalAdmissionHoldUpdated(data.hold)))
      .then(() => toastSuccess('Hold updated successfully'))
      .catch((error) => {
        toastError((error.response && error.response.data && error.response.data.errors || ['An error occurred while updating hold']).join(', '));
        throw error;
      });
  };
};

export const deleteGeneralAdmissionHold = (dispatch, csrfToken, hold) => {
  return dispatch => {
    if(!window.confirm('Are you sure you want to remove this hold? The inventory will be released.')) return Promise.resolve();
    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    const url = `/general_admission_holds/${hold.id}`;
    return axios.delete(url)
      .then(() => {
        dispatch(generalAdmissionHoldDeleted(hold));
        toastSuccess('Hold removed successfully');
      })
      .catch((error) => {
        toastError((error.response && error.response.data && error.response.data.errors || ['An error occurred while removing hold']).join(', '));
      });
  };
};


export const seatingChartEventsChanged = (seatingChartEvents) => ({
  type: SEATING_CHART_EVENTS_CHANGED,
  seatingChartEvents
});
